"use client";
import { jsx } from 'react/jsx-runtime';
import colors from '@optimizely/design-tokens/dist/json/colors.json';
import { faSpinner } from '@optimizely/pro-light-svg-icons';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Icon } from '../Icon/icon.js';

const Spinner = ({
  className,
  hasOverlay,
  size = "large",
  testSection,
  ...props
}) => {
  const spinner = /* @__PURE__ */ jsx(
    Icon,
    {
      className: classNames("axiom-spinner fa-spin-pulse", className),
      color: colors.brandPrimaryColor,
      "data-test-section": testSection,
      icon: faSpinner,
      size,
      ...props
    }
  );
  if (hasOverlay) {
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: "oui-overlay",
        "data-oui-component": true,
        "data-test-section": testSection,
        children: spinner
      }
    );
  }
  return spinner;
};
Spinner.propTypes = {
  /** CSS class names. */
  className: PropTypes.string,
  /** boolean class for establish overlay */
  hasOverlay: PropTypes.bool,
  /** Various sizes. Defaults to large. */
  size: PropTypes.oneOf(["small", "medium", "large"]),
  /** Hook for automated JavaScript tests */
  testSection: PropTypes.string
};
Spinner.displayName = "Spinner";

export { Spinner as default };
